import { useEffect, useState, useRef } from "react";
import { useParams, Navigate } from "react-router-dom";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Campaign redirect mapping
const CAMPAIGN_REDIRECTS: Record<string, string> = {
  // QR Code campaigns
  qr1: "/", // Door hangers
  qr2: "/", // Business cards
};

const CampaignRedirect = () => {
  const { campaignId } = useParams<{ campaignId: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
  const hasTracked = useRef(false);

  useEffect(() => {
    const handleCampaignRedirect = async () => {
      if (!campaignId) {
        setRedirectUrl("/");
        setIsLoading(false);
        return;
      }

      // Prevent double tracking
      if (hasTracked.current) {
        return;
      }
      hasTracked.current = true;

      // Determine redirect URL based on campaign ID
      const targetUrl = CAMPAIGN_REDIRECTS[campaignId] || "/";
      setRedirectUrl(targetUrl);
      setIsLoading(false);

      // Track the campaign visit (fire-and-forget, don't wait for it)
      trackCampaignVisit(campaignId).catch((error) => {
        console.error("Failed to track campaign visit:", error);
      });
    };

    handleCampaignRedirect();
  }, [campaignId]);

  if (isLoading) {
    return;
  }

  return <Navigate to={redirectUrl || "/"} replace />;
};

// Simple tracking function - fire and forget
const trackCampaignVisit = async (campaignId: string) => {
  // Send tracking data to your server
  await fetch(`${API_BASE_URL}/analytics/track-campaign`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      campaignId,
      resolved_to: CAMPAIGN_REDIRECTS[campaignId] || "/",
    }),
  });
};

export default CampaignRedirect;
